// TODO: Clean up how we treat values as both dates and strings
import { ValidationType } from '@/constants/validationTypes';
import { Validation } from '../../sceneDataSchema';
import { z } from 'zod';

export function dateValidator(validations: Validation[]) {
  let required = false;

  const refinedSchema = validations.reduce(
    (schema, validation) => {
      switch (validation.type) {
        case ValidationType.Min: {
          if (typeof validation.value == 'number') {
            return schema;
          }

          const minDate = new Date(validation.value);
          return schema.refine(
            (val) => {
              try {
                const source = new Date(val);
                const target = new Date(minDate);
                return source.getTime() >= target.getTime();
              } catch (error) {
                console.warn(error);
                return false;
              }
            },
            `Date must be on or after ${String(minDate.getUTCMonth() + 1).padStart(2, '0')}/${String(minDate.getUTCDate()).padStart(2, '0')}/${minDate.getUTCFullYear()}`
          );
        }

        case ValidationType.Max: {
          if (typeof validation.value == 'number') {
            return schema;
          }

          const maxDate = new Date(validation.value);
          return schema.refine(
            (val) => {
              try {
                const source = new Date(val);
                const target = new Date(maxDate);
                return source.getTime() <= target.getTime();
              } catch (error) {
                console.warn(error);
                return false;
              }
            },
            `Date must be on or before ${String(maxDate.getUTCMonth() + 1).padStart(2, '0')}/${String(maxDate.getUTCDate()).padStart(2, '0')}/${maxDate.getUTCFullYear()}`
          );
        }

        case ValidationType.Required:
          required = true;

          return schema.refine((val) => val.trim() !== '', 'Field is required');
        default:
          return schema;
      }
    },
    z.string({ message: 'Please enter a valid date' })
  );

  if (required) {
    return refinedSchema;
  }

  return refinedSchema.nullable();
}
